import React from "react";
import { Link } from "react-router-dom";
import { GooglePlay, AppStore, FB, IG, IN, TW, YT } from "../../../components/Icons";
import { useTranslation } from "../../../hooks/useTranslation";
import style from "./index.module.css";
import { vehicleModules, vehicleTypes } from "../../../utils/GeneralTypes";

const Footer = () => {
  const { locale } = useTranslation();
  const facebook_url = process.env.REACT_APP_CONTACTUS_FACEBOOK
  const linkedin_url = process.env.REACT_APP_CONTACTUS_LINKEDIN
  const tiktok_url = process.env.REACT_APP_CONTACTUS_TIKTOK
  const instagram_url = process.env.REACT_APP_CONTACTUS_INSTAGRAM
  const playstore_url = process.env.REACT_APP_CONTACTUS_PLAYSTORE
  const playstore_fallback_url = process.env.REACT_APP_CONTACTUS_PLAYSTORE_FALLBACK
  const appstore_url = process.env.REACT_APP_CONTACTUS_APPSTORE
  const appstore_fallback_url = process.env.REACT_APP_CONTACTUS_FALLBACK
  const handleRedirect = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault(); // Prevent default link behavior

    if (navigator.userAgent.toLowerCase().includes("android")) {
      window.location.href = playstore_url as string;
    } else {
      window.location.href = playstore_fallback_url as string;
    }
  };

  return (
    <footer className={style.main_footer}>
      <div className="container-lg">
        <div className="section_content_padding">
          <div className="row">
            <div className="col-md-9">
              <div className="row">
                <div className="col-md-4">
                  <h3>{locale("quick_links")}</h3>
                  <ul>
                    <li>
                      <Link to="/">{locale("home")}</Link>
                    </li>
                    {vehicleModules.map((vehicleModule) => (
                      <li key={vehicleModule.single + "quick_links"}>
                        <Link to={`/new-${vehicleModule.plural}/find`}>{locale(vehicleModule.single)}</Link>
                      </li>
                    ))}
                    <li>
                      <Link to="/news">{locale("news")}</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <h3>{locale("companies")}</h3>
                  <ul>
                    <li>
                      <Link to="/showrooms">{locale("showrooms")}</Link>
                    </li>
                    <li>
                      <Link to="/service-centers">{locale("service_centers")}</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4">
                  <h3>{locale("our_team")}</h3>
                  <ul>
                    <li>
                      <Link to="/privacy-policy">{locale("privacy_policy")}</Link>
                    </li>
                    <li>
                      <Link to="/terms-conditions">{locale("terms_conditions")}</Link>
                    </li>
                    <li>
                      <Link to="/contact">{locale("contact_us")}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <h3>{locale("connect_w_us")}</h3>
              <ul className={style.social_menu}>
                <li>
                  <a href={facebook_url} target="_blank" rel="noreferrer">
                    <FB width="30" height="30" color="#fff" />
                  </a>
                </li>
                {/*
                <li>
                  <a href="#" target="_blank" rel="noreferrer">
                    <TW width="30" height="30" color="#fff" />
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank" rel="noreferrer">
                    <YT width="30" height="30" color="#fff" />
                  </a>
                </li>
                <li>
                  <a href={instagram_url} target="_blank" rel="noreferrer">
                    <IG width="30" height="30" color="#fff" />
                  </a>
                </li>
                */}
                <li>
                  <a href={linkedin_url} target="_blank" rel="noreferrer">
                    <IN width="30" height="30" color="#fff" />
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a href={playstore_fallback_url} target="_blank" rel="noreferrer" onClick={handleRedirect}>
                    <GooglePlay width="187" height="60" color="#fff" />
                  </a>
                </li>
                {/*
                <li>
                  <a href={appstore_url} target="_blank" rel="noreferrer">
                    <AppStore width="187" height="60" color="#fff" />
                  </a>
                </li>
                */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
